import { render, staticRenderFns } from "./CultureActivityAudit.vue?vue&type=template&id=ff0a4010&scoped=true&"
import script from "./CultureActivityAudit.vue?vue&type=script&lang=js&"
export * from "./CultureActivityAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0a4010",
  null
  
)

export default component.exports